import api from '@/api'

export default {
  fetch () {
    return api.get('/series')
  }
}
